
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30757',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30757",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55277",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8312",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11766",
  "I18n": "static-7.1669",
  "quartz": "static-1.7431",
  "quartz-config": "static-1.1209",
  "quartz-core": "static-1.6650",
  "react-dlb": "static-1.88",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.900",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55264",
  "feedback-utils": "static-1.55268",
  "forms-embed-utils-lib": "static-1.4744",
  "forms-utils-lib": "static-1.13066",
  "foundations-assets": "static-1.5163",
  "foundations-components": "static-1.8461",
  "foundations-theming": "static-1.4752",
  "hub-http": "static-1.6492",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12073",
  "icons": "static-2.678",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4117",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16997",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5542",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.501",
  "tinymce-plugins": "static-1.58178",
  "transmute": "static-2.85",
  "ui-images": "static-2.1239",
  "UIComponents": "static-3.8712",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3606",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3708",
  "quartz-webpack": "static-1.3655",
  "foundations-theming-specialty": "static-1.2468",
  "property-description-translator": "static-1.4120",
  "HeadJS": "static-2.794",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3423",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4594",
  "jasmine-runner": "static-1.6733",
  "opentelemetry-fe-types": "static-1.50",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.875",
  "hubspotter-http": "static-1.4850",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.425",
  "quartz-auth": "static-1.1106",
  "quartz-head": "static-1.1096",
  "quartz-i18n": "static-1.1106",
  "quartz-routing": "static-1.861",
  "quartz-test": "static-1.1106",
  "quartz-tracking": "static-1.810",
  "trellis-components": "static-1.2606",
  "ui-fonts": "static-1.1028",
  "usage-tracker-container": "static-1.7625",
  "usage-tracker-core": "static-1.7485",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.172",
  "conversations-skeleton-state": "static-1.7526",
  "reference-resolvers": "static-1.8461",
  "sanitize-text": "static-1.8434",
  "PatternValidationJS": "static-1.3174",
  "ReduxMessenger": "static-2.10649",
  "outpost": "static-1.4437",
  "rpc-client-utils": "static-1.4946",
  "sanitize": "static-1.4753",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4730",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9706",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.68",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2587",
  "bend-plugin-foundations-theming": "static-1.3235",
  "foundations-theming-base": "static-1.3737",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.279",
  "csstype": "static-1.50",
  "web-vitals": "static-1.12",
  "ai-components-ui-library": "static-1.9670",
  "atom": "static-1.5365",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8172",
  "ContentUtils": "static-1.69086",
  "data-token-picker": "static-1.16859",
  "file-manager-components": "static-1.24442",
  "FileManagerCore": "static-1.39941",
  "FileManagerLib": "static-1.40082",
  "frontend-preferences-client": "static-1.8203",
  "hub-http-contrib": "static-1.3318",
  "interframe": "static-3.5035",
  "layout-dnd-components": "static-1.12937",
  "layout-dnd-utils": "static-1.11912",
  "property-translator": "static-1.5677",
  "react-codemirror": "static-1.10919",
  "react-colorpicker": "static-2.10492",
  "reference-resolvers-lite": "static-1.8381",
  "rich-text-lib": "static-1.20277",
  "tinymce-data": "static-1.41149",
  "tinymce-themes": "static-1.57034",
  "ui-addon-emoji-picker": "static-1.10165",
  "ui-addon-sales-email": "static-1.5492",
  "ui-brand-identity-lib": "static-1.16400",
  "bender-build-tools": "static-1.3425",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10582",
  "hubspotter-http-shared-msw-handlers": "static-1.10580",
  "usage-tracker-session-replay": "static-1.5321",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1254",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.356",
  "chirp-fetch": "static-1.2174",
  "stylex-utils": "static-1.138",
  "chatspot-core": "static-1.22884",
  "copilot-toolkit": "static-1.11816",
  "customer-data-objects-ui-components": "static-1.13311",
  "data-fetching-client": "static-1.9936",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5036",
  "ui-addon-video-player": "static-1.8983",
  "ui-coaching-tips": "static-1.29267",
  "usage-tracker": "static-1.7635",
  "cms-field-types": "static-1.5095",
  "content-icons-ui": "static-1.2343",
  "integrations-lib": "static-1.16989",
  "customer-data-objects": "static-1.7970",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1669",
  "apollo-link-hub-http": "static-2.4935",
  "apollo-stack-hubspot": "static-3.91",
  "graphql": "static-1.86",
  "immer": "static-1.98",
  "immerable": "static-1.4430",
  "ui-addon-iframeable": "static-1.9357",
  "video-components-external": "static-1.12116",
  "video-data-lib": "static-1.35774",
  "breeze-artifacts-sdk": "static-1.269",
  "audio-components": "static-1.6314",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29779",
  "FileManagerImages": "static-1.37593",
  "foundations-components-legacy": "static-1.1486",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.543",
  "ui-universal-auth": "static-1.9363",
  "urlinator": "static-1.4813",
  "video-components": "static-1.14118",
  "video-embed": "static-1.36608",
  "ts-schema": "static-1.4279",
  "ContentData": "static-1.69161",
  "layout-data-lib": "static-1.10237",
  "react-dnd-compat": "static-1.4897",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1823",
  "external-options-client-types": "static-1.4325",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7172",
  "hs-promise-utils": "static-1.5877",
  "inbound-db-properties-service-client": "static-1.4042",
  "NamespacedHubStyle": "static-2.9249",
  "growth-onboarding-confetti": "static-1.3342",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11426",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5739",
  "magpie-types": "static-1.5199",
  "simple-logging-lib": "static-1.3330",
  "avatar-components": "static-1.2766",
  "customer-data-ui-utilities": "static-1.10109",
  "growth-onboarding-feedback-components": "static-1.6864",
  "flux-actions": "static-1.366",
  "hubspot-apollo-client": "static-1.5159",
  "integrations-error-boundary-lib": "static-1.14404",
  "integrations-tracking-lib": "static-1.5888",
  "laboratory-lib": "static-3.7431",
  "native-integrations-shared-strings": "static-1.8058",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10549",
  "unified-auth": "static-1.877",
  "breeze-engine-chat-components": "static-1.647",
  "breeze-engine-core": "static-1.947",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8112",
  "content-media-composition-data-lib": "static-1.13196",
  "content-media-compositions": "static-2.17203",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19378",
  "unified-auth-core-lib": "static-1.1159",
  "social-insights-client-types": "static-1.22698",
  "advanced-menus-core": "static-1.15548",
  "advanced-menus-lib": "static-1.12425",
  "ExportDialog": "static-6.10657",
  "ui-memberships-settings-lib": "static-1.34803",
  "conditional-properties-service-client": "static-1.3998",
  "crm-pipelines-api-client-types": "static-1.4333",
  "fdsr-migration-layer": "static-1.291",
  "framework-builder-read-service-client": "static-1.4207",
  "framework-data-schema-quick-fetch": "static-1.7077",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3894",
  "persist-promise": "static-1.3980",
  "foundations-components-test-utils": "static-1.5944",
  "reactive-lib": "static-1.999",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.618",
  "universal-page-editor-lib": "static-1.3287",
  "adobe-sign-auth-lib": "static-1.422",
  "ads-unified-auth-lib": "static-1.1242",
  "google-sheets-integration-lib": "static-1.990",
  "microsoft-drive-auth-lib": "static-1.92",
  "surveymonkey-integration-lib": "static-1.432",
  "slack-ui-library": "static-1.10678",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4029",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15547",
  "simple-menus-lib": "static-1.17064",
  "crm-record-cards-service-types": "static-1.3772",
  "location-customization-utils-lib": "static-1.10058",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30757",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55277",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8312",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11766",
  "I18n": "/I18n/static-7.1669",
  "quartz": "/quartz/static-1.7431",
  "quartz-config": "/quartz-config/static-1.1209",
  "quartz-core": "/quartz-core/static-1.6650",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.900",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55264",
  "feedback-utils": "/feedback-utils/static-1.55268",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4744",
  "forms-utils-lib": "/forms-utils-lib/static-1.13066",
  "foundations-assets": "/foundations-assets/static-1.5163",
  "foundations-components": "/foundations-components/static-1.8461",
  "foundations-theming": "/foundations-theming/static-1.4752",
  "hub-http": "/hub-http/static-1.6492",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12073",
  "icons": "/icons/static-2.678",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4117",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16997",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5542",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tinymce-plugins": "/tinymce-plugins/static-1.58178",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1239",
  "UIComponents": "/UIComponents/static-3.8712",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3606",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3708",
  "quartz-webpack": "/quartz-webpack/static-1.3655",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2468",
  "property-description-translator": "/property-description-translator/static-1.4120",
  "HeadJS": "/HeadJS/static-2.794",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3423",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4594",
  "jasmine-runner": "/jasmine-runner/static-1.6733",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.50",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.875",
  "hubspotter-http": "/hubspotter-http/static-1.4850",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.425",
  "quartz-auth": "/quartz-auth/static-1.1106",
  "quartz-head": "/quartz-head/static-1.1096",
  "quartz-i18n": "/quartz-i18n/static-1.1106",
  "quartz-routing": "/quartz-routing/static-1.861",
  "quartz-test": "/quartz-test/static-1.1106",
  "quartz-tracking": "/quartz-tracking/static-1.810",
  "trellis-components": "/trellis-components/static-1.2606",
  "ui-fonts": "/ui-fonts/static-1.1028",
  "usage-tracker-container": "/usage-tracker-container/static-1.7625",
  "usage-tracker-core": "/usage-tracker-core/static-1.7485",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.172",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7526",
  "reference-resolvers": "/reference-resolvers/static-1.8461",
  "sanitize-text": "/sanitize-text/static-1.8434",
  "PatternValidationJS": "/PatternValidationJS/static-1.3174",
  "ReduxMessenger": "/ReduxMessenger/static-2.10649",
  "outpost": "/outpost/static-1.4437",
  "rpc-client-utils": "/rpc-client-utils/static-1.4946",
  "sanitize": "/sanitize/static-1.4753",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4730",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9706",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2587",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3235",
  "foundations-theming-base": "/foundations-theming-base/static-1.3737",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.279",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.12",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9670",
  "atom": "/atom/static-1.5365",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8172",
  "ContentUtils": "/ContentUtils/static-1.69086",
  "data-token-picker": "/data-token-picker/static-1.16859",
  "file-manager-components": "/file-manager-components/static-1.24442",
  "FileManagerCore": "/FileManagerCore/static-1.39941",
  "FileManagerLib": "/FileManagerLib/static-1.40082",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8203",
  "hub-http-contrib": "/hub-http-contrib/static-1.3318",
  "interframe": "/interframe/static-3.5035",
  "layout-dnd-components": "/layout-dnd-components/static-1.12937",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11912",
  "property-translator": "/property-translator/static-1.5677",
  "react-codemirror": "/react-codemirror/static-1.10919",
  "react-colorpicker": "/react-colorpicker/static-2.10492",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8381",
  "rich-text-lib": "/rich-text-lib/static-1.20277",
  "tinymce-data": "/tinymce-data/static-1.41149",
  "tinymce-themes": "/tinymce-themes/static-1.57034",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10165",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5492",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16400",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10582",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10580",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5321",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1254",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.356",
  "chirp-fetch": "/chirp-fetch/static-1.2174",
  "stylex-utils": "/stylex-utils/static-1.138",
  "chatspot-core": "/chatspot-core/static-1.22884",
  "copilot-toolkit": "/copilot-toolkit/static-1.11816",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13311",
  "data-fetching-client": "/data-fetching-client/static-1.9936",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5036",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8983",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29267",
  "usage-tracker": "/usage-tracker/static-1.7635",
  "cms-field-types": "/cms-field-types/static-1.5095",
  "content-icons-ui": "/content-icons-ui/static-1.2343",
  "integrations-lib": "/integrations-lib/static-1.16989",
  "customer-data-objects": "/customer-data-objects/static-1.7970",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1669",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4935",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.98",
  "immerable": "/immerable/static-1.4430",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9357",
  "video-components-external": "/video-components-external/static-1.12116",
  "video-data-lib": "/video-data-lib/static-1.35774",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.269",
  "audio-components": "/audio-components/static-1.6314",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29779",
  "FileManagerImages": "/FileManagerImages/static-1.37593",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1486",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.543",
  "ui-universal-auth": "/ui-universal-auth/static-1.9363",
  "urlinator": "/urlinator/static-1.4813",
  "video-components": "/video-components/static-1.14118",
  "video-embed": "/video-embed/static-1.36608",
  "ts-schema": "/ts-schema/static-1.4279",
  "ContentData": "/ContentData/static-1.69161",
  "layout-data-lib": "/layout-data-lib/static-1.10237",
  "react-dnd-compat": "/react-dnd-compat/static-1.4897",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1823",
  "external-options-client-types": "/external-options-client-types/static-1.4325",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7172",
  "hs-promise-utils": "/hs-promise-utils/static-1.5877",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4042",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9249",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3342",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11426",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5739",
  "magpie-types": "/magpie-types/static-1.5199",
  "simple-logging-lib": "/simple-logging-lib/static-1.3330",
  "avatar-components": "/avatar-components/static-1.2766",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10109",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6864",
  "flux-actions": "/flux-actions/static-1.366",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5159",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14404",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5888",
  "laboratory-lib": "/laboratory-lib/static-3.7431",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8058",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10549",
  "unified-auth": "/unified-auth/static-1.877",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.647",
  "breeze-engine-core": "/breeze-engine-core/static-1.947",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8112",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13196",
  "content-media-compositions": "/content-media-compositions/static-2.17203",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19378",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1159",
  "social-insights-client-types": "/social-insights-client-types/static-1.22698",
  "advanced-menus-core": "/advanced-menus-core/static-1.15548",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12425",
  "ExportDialog": "/ExportDialog/static-6.10657",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34803",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3998",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4333",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.291",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4207",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7077",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3894",
  "persist-promise": "/persist-promise/static-1.3980",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5944",
  "reactive-lib": "/reactive-lib/static-1.999",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.618",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3287",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.422",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1242",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.990",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.92",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.432",
  "slack-ui-library": "/slack-ui-library/static-1.10678",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4029",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15547",
  "simple-menus-lib": "/simple-menus-lib/static-1.17064",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3772",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10058",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
